import {Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import SUGMTabs from './SUGMTabs';

const {Paragraph} = Typography;
const Content = Layout;

const SUGM = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-10vh'}}>Software Usage Guide</Paragraph>
      </Content>
      <SUGMTabs/>
    </Layout>
  );
};

export default SUGM;
